import axios from "./axios";

export async function fetchJournalRange({ from, to }) {
  const res = await axios.get("/work_journal_entries", { params: { from, to } });
  return res?.data?.data ?? [];
}

export async function fetchJournalDay(date) {
  const res = await axios.get("/work_journal_entries/day", { params: { date } });
  return res?.data?.data ?? { body_html: "", entry_on: date };
}

export async function saveJournalDay(date, body_html) {
  const res = await axios.put("/work_journal_entries/day", { date, body_html });
  return res?.data?.data;
}

export async function updateTodoDigestPreferences(payload) {
  const res = await axios.patch("/users/me/todo_digest_preferences", { user: payload });
  return res?.data;
}
